import { render, staticRenderFns } from "./ModalLiberarRepasses.vue?vue&type=template&id=a684b910"
import script from "./ModalLiberarRepasses.vue?vue&type=script&lang=ts"
export * from "./ModalLiberarRepasses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports